/** Fixed Indian country code used across admin forms. */
export const FIXED_COUNTRY_CODE = "+91";

/** Normalize user input to up to 10 mobile digits. */
export const sanitizeMobileDigits = (raw) =>
  (raw ?? "").toString().replace(/\D/g, "").slice(0, 10);
